export default __webpack_public_path__ + "static/media/robotBody.5941a660.png";